// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 50px;
  bottom: 0;
  left: 0;
  z-index: 100;
  padding: 50px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
}

#wrapper {
  overflow-x: hidden;
}

#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -10rem;
  margin-right: 2rem;
  z-index: 100;
  transition: margin .25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 5rem;
}

#page-content-wrapper {
  min-width: 100vw;
  margin-left: auto;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

[role="main"] {
  padding-top: 15px;
}

@media (max-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
    min-width: 50px;
    margin-right: 0;
  }

  #page-content-wrapper {
    width: 100%;
    padding-left: 80px;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: 0;
    min-width: 150px;
  }

  .text {
    display: none !important;
  }
}

.text {
  display: inline;
  margin: 0;
}

:host nb-layout-header nb-user:last-child {
  margin-left: auto;
}



/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/feature-modules/welfy-container/welfy-container.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EAIZ,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;;;AACA,4kFAA4kF","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 50px;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  padding: 50px 0 0;\n  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);\n}\n\n#wrapper {\n  overflow-x: hidden;\n}\n\n#sidebar-wrapper {\n  min-height: 100vh;\n  margin-left: -10rem;\n  margin-right: 2rem;\n  z-index: 100;\n  -webkit-transition: margin .25s ease-out;\n  -moz-transition: margin .25s ease-out;\n  -o-transition: margin .25s ease-out;\n  transition: margin .25s ease-out;\n}\n\n#sidebar-wrapper .sidebar-heading {\n  padding: 0.875rem 1.25rem;\n  font-size: 1.2rem;\n}\n\n#sidebar-wrapper .list-group {\n  width: 5rem;\n}\n\n#page-content-wrapper {\n  min-width: 100vw;\n  margin-left: auto;\n}\n\n#wrapper.toggled #sidebar-wrapper {\n  margin-left: 0;\n}\n\n[role=\"main\"] {\n  padding-top: 15px;\n}\n\n@media (max-width: 768px) {\n  #sidebar-wrapper {\n    margin-left: 0;\n    min-width: 50px;\n    margin-right: 0;\n  }\n\n  #page-content-wrapper {\n    width: 100%;\n    padding-left: 80px;\n  }\n\n  #wrapper.toggled #sidebar-wrapper {\n    margin-left: 0;\n    min-width: 150px;\n  }\n\n  .text {\n    display: none !important;\n  }\n}\n\n.text {\n  display: inline;\n  margin: 0;\n}\n\n:host nb-layout-header nb-user:last-child {\n  margin-left: auto;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
